import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { QUERY_KEYS } from '../../queryKeys';
import { documentManagement } from '../DocumentManagement';

export const useDocumentTypes = () =>
  useQuery({
    queryKey: [QUERY_KEYS.documentManagementDocumentType],
    queryFn: async () => (await documentManagement.getDocumentTypes()).data,
  });

export const useCreateDocumentType = () =>
  useMutation({
    mutationFn: documentManagement.createDocumentType,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.documentManagementDocumentType],
      }),
  });

export const useDeleteDocumentType = () =>
  useMutation({
    mutationFn: documentManagement.deleteDocumentType,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.documentManagementDocumentType],
      }),
  });
